// Extension integration is intentionally disabled — this is a Jellyfin-only frontend.

export const RULE_IDS = {
  PREPARE_STREAM: 1,
  SET_DOMAINS_HLS: 2,
  SET_DOMAINS_HLS_AUDIO: 3,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function sendExtensionRequest<T>(
  ..._args: unknown[]
): Promise<T | null> {
  return null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function setDomainRule(..._args: unknown[]): Promise<null> {
  return null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function sendPage(..._args: unknown[]): Promise<null> {
  return null;
}

export async function extensionInfo(): Promise<null> {
  return null;
}

export function isExtensionActiveCached(): boolean {
  return false;
}

export async function isExtensionActive(): Promise<boolean> {
  return false;
}
